module.exports = __webpack_public_path__ + "img/vr_cover.108105fa.png";